import { graphqlPost } from "api/graphqlClient";
import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./IdentityRole.reducer";

/**
 * Create identity<>role association
 */
export function* createIdentityRole({ promise, params }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.CREATE_IDENTITYROLE_SUCCESSFUL,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.CREATE_IDENTITYROLE_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Delete identity<>role association
 */
export function* deleteIdentityRole({ promise, params }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.DELETE_IDENTITYROLE_SUCCESSFUL,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.DELETE_IDENTITYROLE_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Update identity<>role association
 */
export function* updateIdentityRole({ promise, params }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.UPDATE_IDENTITYROLE_SUCCESSFUL,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.UPDATE_IDENTITYROLE_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

function* fetchIdentityRoleList({ promise, iri, params }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.FETCH_IDENTITYROLE_LIST_SUCCESSFUL,
            iri,
            response: apiResult?.data,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.FETCH_IDENTITYROLE_LIST_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

function* fetchIdentityRoleListInitialCount({ promise, iri, params }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.FETCH_IDENTITYROLE_LIST_INITIAL_COUNT_SUCCESSFUL,
            iri,
            response: apiResult?.data,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.FETCH_IDENTITYROLE_LIST_INITIAL_COUNT_FAILED,
        });
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Register action to watcher
 */
export default [
    takeLatest(actions.START_CREATE_IDENTITYROLE, createIdentityRole),
    takeLatest(actions.START_DELETE_IDENTITYROLE, deleteIdentityRole),
    takeLatest(actions.START_UPDATE_IDENTITYROLE, updateIdentityRole),
    takeLatest(actions.START_FETCH_IDENTITYROLE_LIST, fetchIdentityRoleList),
    takeLatest(
        actions.START_FETCH_IDENTITYROLE_LIST_INITIAL_COUNT,
        fetchIdentityRoleListInitialCount
    ),
];
